<div class="flex flex-row justify-between pb-3 pr-2 relative items-center">
    <div class="flex flex-row items-center">
        <h2 mat-dialog-title class="!pl-0 md:text-2xl sm:text-xl text-xl !m-0 font-bold !text-blue-theme-color">
            {{this.heading}}</h2>
    </div>
    <button mat-icon-button class="dialog-close-btn flex items-center justify-center" mat-dialog-close>
        <mat-icon class="text-blue-theme-color text-xl">close</mat-icon>
    </button>
</div>
<mat-dialog-content class="mt-16 pt-4 !py-0"> 
    <div class="border-2 border-orange-color flex flex-col justify-between pt-3 pb-1 px-4">
        <div class="flex justify-between items-center" *ngFor="let item of this._data.dropPoints; let i = index">
            <div class="text-base py-1 font-medium text-blue-theme-color" [ngClass]="i == this._data.dropPoints.length - 1 ? 'mb-1' : ''">{{item.name}}</div>
            <!-- <div class="text-lg py-1 font-semibold text-blue-theme-color" [ngClass]="i == this._data.dropPoints.length - 1 ? 'mb-1' : ''">{{this._data.currency}} {{item.status == 1 ? item.payToCustomer : item.orderClosurePrice}}</div> -->
            <div class="text-lg py-1 font-semibold text-blue-theme-color" [ngClass]="i == this._data.dropPoints.length - 1 ? 'mb-1' : ''">{{this._data.currency}} {{getDropLabel(item)}}</div>
        </div>
        <div class="flex justify-between items-center border-t-2 border-orange-color">
            <div class="text-base py-3 font-medium text-blue-theme-color">Total</div>
            <div class="text-lg py-3 font-semibold text-blue-theme-color">{{this._data.currency}} {{this._data.orderCloser.orderCloserTotal}}</div>
        </div>
        <!-- <div class="flex justify-between items-center border-t-2 border-orange-color">
            <div class="text-base py-3 font-medium text-blue-theme-color">Total Abjusted Price</div>
            <div class="text-lg py-3 font-semibold text-blue-theme-color">{{this._data.currency}} {{this._data.orderCloser.orderCloserAfterCNDchange}}</div>
        </div> -->
    </div>
    <div class="flex justify-between items-center px-4 bg-orange-color text-white-color">
        <div class="text-base py-3 font-medium">Final Delivery Fee</div>
        <div class="text-lg py-3 font-semibold">{{this._data.currency}} {{this._data.orderCloser.orderCloserTotal}}</div>
    </div>
</mat-dialog-content>
<mat-dialog-actions class="!pb-4 flex justify-center pt-2">
    <button color="primary" class="!bg-blue-theme-color mx-auto md:w-auto sm:w-full w-full !px-6 !h-11 text-white-color ml-auto mr-0" mat-dialog-close mat-flat-button>OKAY</button>
</mat-dialog-actions>